import { useState } from 'react'
import { ConfigProvider, Form } from 'antd';
import { Button, Input } from "mobily-ui-library/lib";

import { sendEmailRequest } from '../../api/api';
import { getAccountDetails } from '../../api/apigeeApi';
import { Error } from '../../util/Error';

import './DeviceLoginForm.scss'

interface Props {
    rtl: boolean;
    setLoading: (flag: boolean) => void;
}

const win: any = window;

function DeviceLoginForm({ rtl, setLoading }: Props) {
    const [form] = Form.useForm();

    const [mobileNumber, setMobileNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [crNumber, setCrNumber] = useState('');
    const [authorizedPerson, setAuthorizedPerson] = useState('');

    const newEmail = window.location.origin.includes("mobily.com.sa") ? ['DigitalSalesB2B@mobily.com.sa'] : ['a.hegde@mobily.com.sa'];

    const handleNext = () => {
        setLoading(true);

        getAccountDetails(crNumber)
            .then((res: any) => {
                if (res.status === 200) {
                    if (res.data.ListOfBusinessCustomer.length > 0) {
                        const response = res.data.ListOfBusinessCustomer[0];
                        if (response.CustomerCategory !== 'SMB Unmanaged') {
                            const kamEmails = response.ListOfKAMs.filter((el: any) => el.IsPrimary === 'Y' && el).map((el: any) => el.EmailAddress);
                            sendEmail(kamEmails, kamEmails[0]);
                        } else {
                            sendEmail();
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                        sendEmail();
                    }
                } else {
                    if (res.status === 401) {
                        setLoading(false);
                    }
                    sendEmail();
                }
            })
    };

    const handleCrNumber = (e: any) => {
        const value = e.target.value
        setCrNumber(value)
    }

    const handleMobileNumber = (e: any) => {
        const value = e.target.value;
        setMobileNumber(value);
    }

    const handleCompanyName = (e: any) => {
        const value = e.target.value;
        setCompanyName(value)
    }

    const handlePersonName = (e: any) => {
        const value = e.target.value;
        setAuthorizedPerson(value);
    }
 
    const sendEmail = (email = newEmail, senderName = 'Virtual Sales Team') => {
        const device = document.getElementById('dev-title') ? (document.getElementById('dev-title') as HTMLElement).innerText : "";
        const color = document.getElementById('selected-color') ? (document.getElementById('selected-color') as HTMLElement).innerText : "";
        const capacity = document.getElementById('capacityKey') ? (document.getElementById('capacityKey') as HTMLElement).innerText : "";
        const packages = document.getElementById('packageKey') ? (document.getElementById('packageKey') as HTMLElement).innerText : "";
        const quantity = document.getElementById('dcount') ? (document.getElementById('dcount') as HTMLElement).innerText : "";
        const commitment = document.getElementById('commitmentKey') ? (document.getElementById('commitmentKey') as HTMLElement).innerText : "";
        const price = document.getElementById('ufa') ? (document.getElementById('ufa') as HTMLElement).innerText : "";
        const totalAmount = document.getElementById('ftot') ? (document.getElementById('ftot') as HTMLElement).innerText : "";

        const req = {
            "notifications": [
                {
                    "notificationId": "525616",
                    "notificationType": "EMAIL",
                    "sender": "",
                    "header": "Device order confirmation",
                    "receivers": email,
                    "params": [
                        {
                            "name": "Name",
                            "value": senderName
                        },
                        {
                            "name": "CompanyName",
                            "value": companyName
                        },
                        {
                            "name": "APName",
                            "value": authorizedPerson
                        },
                        {
                            "name": "ContactNum",
                            "value": mobileNumber
                        },
                        {
                            "name": "CRNum",
                            "value": crNumber
                        },
                        {
                            "name": "device",
                            "value": device
                        },
                        {
                            "name": "capacity",
                            "value": capacity
                        },
                        {
                            "name": "color",
                            "value": color
                        },
                        {
                            "name": "package",
                            "value": packages
                        },
                        {
                            "name": "commitment",
                            "value": commitment
                        },
                        {
                            "name": "quantity",
                            "value": quantity
                        },
                        {
                            "name": "price",
                            "value": price
                        },
                        {
                            "name": "amount",
                            "value": totalAmount
                        }
                    ]
                }
            ]
        }

        sendEmailRequest(req)
            .then((res: any) => {
                if (res.status === 204) {
                    win['location'] = win['successPageURL'];
                } else {
                    win['location'] = win['errorPageURL'];
                }
            })
    }

    const direction = rtl ? 'rtl' : 'ltr';

    return (
        <ConfigProvider direction={direction}>
            <Form form={form} name="control-ref" className='DeviceLogin__Form' onFinish={handleNext} >
                <Form.Item
                    initialValue={companyName}
                    name='companyname'
                    hasFeedback
                    className="DL__Input"
                    rules={[
                        { required: true, message: `Please enter Company Name` },
                        {
                            message: `Company Name must be in alphabetic`,
                            pattern: /^[a-zA-Z\s]{2,50}$/
                        }
                    ]}
                >
                    <Input
                        rtl={rtl}
                        name='Company Name'
                        type="text"
                        placeholder=''
                        value={companyName}
                        headingleft='Company Name'
                        onChange={handleCompanyName}
                    />
                </Form.Item>
                <Form.Item
                    initialValue={crNumber}
                    name='crNumber'
                    className="DL__Input"
                    hasFeedback
                    rules={[
                        { required: true, message: `Please enter Commercial Registration Number` },
                        {
                            message: `Commercial Registration Number contains 10 digit in length`,
                            pattern: /^[0-9\s]{10}$/
                        }
                    ]}
                >
                    <Input
                        rtl={rtl}
                        value={crNumber}
                        headingleft='Commercial Registration Number'
                        maxLength={10}
                        onChange={handleCrNumber}
                    />
                </Form.Item>
                <Form.Item
                    initialValue={authorizedPerson}
                    name='authorizedPerson'
                    className="DL__Input"
                    hasFeedback
                    rules={[
                        { required: true, message: `Please enter Authorized Person Name` },
                        {
                            message: `Authorized Person Name must be in alphabetic`,
                            pattern: /^[a-zA-Z\s]{2,50}$/
                        }
                    ]}
                >
                    <Input
                        rtl={rtl}
                        value={authorizedPerson}
                        headingleft='Authorized Person Name'
                        onChange={handlePersonName}
                    />
                </Form.Item>
                <Form.Item
                    initialValue={mobileNumber}
                    name='mobileNumber'
                    className="DL__Input"
                    hasFeedback
                    rules={[
                        { required: true, message: `Please enter Mobile number` },
                        {
                            message: `Mobile number starts with 9665 and contains 12 digits length`,
                            pattern: /^((9665)([0-9]{8}))$/
                        }
                    ]}
                >
                    <Input
                        rtl={rtl}
                        value={mobileNumber}
                        headingleft='Mobile number'
                        maxLength={12}
                        onChange={handleMobileNumber}
                    />
                </Form.Item>
                <Form.Item>
                    <Button rtl={rtl} className="DL__Button" htmlType={'submit'} >
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </ConfigProvider>
    )
}

export default DeviceLoginForm